<template>
    <div id="container">
        <!-- <transition name="slide-left"> -->
      <router-view></router-view>
    <!-- </transition> -->
    </div>
</template>
<script>
export default {
    name: 'PageView'
}
</script>
<!-- <style>
    @media screen and (max-width: 768px) {
    .business, .company, .team {
        padding: 0 10px;
    }
}
.slide-left-enter-active, .slide-left-leave-active {
  transition: transform 0.3s ease;
}

.slide-left-enter, .slide-left-leave-to {
  transform: translateX(-100%);
}

.slide-left-enter-active, .slide-left-leave-active {
  position: absolute;
  width: 100%;
}
</style> -->




// WEBPACK FOOTER //
// src/view/PageView.vue